const pluralizeString = (string: string): string => {
    return string.endsWith("ss") ? `${string}es` : string.endsWith("s") ? string : `${string}s`;
};

export default pluralizeString;